import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFactory } from "../types/IFactory";

export interface IFactoryQueryParameters {
    factory: RelationalValue<IFactory>;
}

export type IFactoryQueryResult = IFactory;

export const factoryQuery: IApiQueryFunction<IFactoryQueryParameters> = ({ factory }) => {
    if (!factory) {
        return;
    }

    return {
        method: "GET",
        url: `/factories/${mapRelationalValue(factory)}`,
    };
};

export const useFactoryQuery = createApiQueryHook<IFactoryQueryParameters, IFactoryQueryResult>(factoryQuery);
